import React, { Component } from "react";
import Subjektif from "./Subjektif.js";
import Objektif from "./Objektif.js";
import Assesment from "./Assesment";
import Planning from "./Planning";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { BMI, BmiCss, BloodPress, BloodPressCss } from "../form/rumus";
import "react-tabs/style/react-tabs.css";
import apiService from "apiService.js";
import printJS from "print-js";
import { DetilPxContext } from "../../context";
import BodyParts from "view/igd/BodyParts.js";

export default class Umum extends Component {
  static contextType = DetilPxContext;
  constructor(props) {
    super(props);
    this.state = {
      visitId: 1000,
      modules: [
        { id: "1", name: "Tubuh" },
        { id: "2", name: "Subjektif" },
        { id: "3", name: "Objektif" },
        { id: "4", name: "Assesment" },
        { id: "5", name: "Planning" },
      ],
      visible: false,
      detilPx: this.props.detilPx,
      tabIndex: 0,
    };
    this.parentCallback = this.parentCallback.bind(this);
    this.nextTab = this.nextTab.bind(this);
  }

  buttonClick = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    // console.log(this.state);
  };

  parentCallback(data) {
    this.setState((prevState) => ({
      detilPx: {
        // object that we want to update
        ...prevState.detilPx, // keep all other key-value pairs
        [data.param]: data.data,
      },
    }));
    // console.log(data);
  }

  getData = async () => {
    let param = {
      keyword: {
        visitId: this.state.detilPx.id,
      },
      limit: 10,
      frDate: "",
      enDate: "",
    };

    const res = await apiService.post("registration", param);
    // console.log(res)
    if (res?.status === "success.") {
      this.setState({
        detilPx: res.data.data[0],
      });
      this.context.changeDetilPx(res.data.data[0]);
      this.forceUpdate();
    }
  };

  requestPrint = async () => {
    const res = await apiService.getblob(
      "/registration/print/informed_consent/" + this.state.detilPx.id
    );
    if (res) {
      const file = new Blob([res], { type: "application/pdf" });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //print blob
      printJS(fileURL);
    }
  };

  nextTab() {
    const tabs = this.state.tabIndex;
    const tabIndex = tabs + 1;
    this.setState({ tabIndex: tabIndex });
    window.scrollTo(0, 50);
  }

  render() {
    var patient = this.state.detilPx;
    return (
      <div>
        <div className="card">
          <div className="card-header">
            <div className="row align-items-center">
              <div className="col row">
                <h4 className="h3 mb-0 ">Form Pemeriksaan Umum</h4>
                <div className="ml-2 mt--1">
                  <a
                    className="btn btn-sm btn-twitter btn-icon-only rounded-circle"
                    onClick={this.getData}
                  >
                    <i
                      className="fa fa-refresh"
                      style={{ color: "white" }}
                      aria-hidden="true"
                    ></i>
                  </a>
                </div>
                <div className="ml-2 mt--1">
                  <button
                    className="btn btn-sm btn-info"
                    onClick={() => this.requestPrint()}
                  >
                    cetak persetujuan tindakan
                  </button>
                </div>
              </div>
              <div
                className={BmiCss(
                  patient.examinations[0].weight,
                  patient.examinations[0].height
                )}
              >
                {BMI(
                  patient.examinations[0].weight,
                  patient.examinations[0].height
                )}
              </div>
              <div
                className={BloodPressCss(
                  patient.examinations[0].sistole,
                  patient.examinations[0].diastole
                )}
                style={{ marginLeft: "2%" }}
              >
                <b>
                  {" "}
                  {BloodPress(
                    patient.examinations[0].sistole,
                    patient.examinations[0].diastole
                  )}{" "}
                </b>
              </div>
            </div>
          </div>
          <div className="card-body">
            <Tabs
              selectedIndex={this.state.tabIndex}
              onSelect={(tabIndex) => this.setState({ tabIndex })}
            >
              <TabList>
                <Tab id="Tubuh">Tubuh </Tab>
                <Tab id="Subjektif">Subjektif </Tab>
                <Tab id="Objektif">Objektif </Tab>
                <Tab id="Assesment">Assesment </Tab>
                <Tab id="Planning">Planning </Tab>
              </TabList>
              <TabPanel tabId="Tubuh">
                <BodyParts patient={patient} />
              </TabPanel>
              <TabPanel tabId="Subjektif">
                <Subjektif
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
              <TabPanel tabId="Objektif">
                <Objektif
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
              <TabPanel tabId="Assesment">
                <Assesment
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                />
              </TabPanel>
              <TabPanel tabId="Planning">
                <Planning
                  patient={patient}
                  parentCallback={this.parentCallback}
                  history={this.props.history}
                  nextTab={this.nextTab}
                  getData={this.getData}
                />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}
